import { Routes, Route } from "react-router-dom";
import DlashopLayout from "./DlashopLayout";
import AllProducts from "./shoppages/AllProducts";
import ProductDetailPage from "./shoppages/ProductDetailPage";
import CategoryProducts from "./shoppages/CategoryProducts";
import Checkout from "./shoppages/Checkout";

const DlashopRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<DlashopLayout />}>
        {/* Default Page - All Products */}
        <Route index element={<AllProducts />} />
        
        {/* All Products Page (explicit route) */}
        <Route path="all" element={<AllProducts />} />
        
        {/* Category Products Page */}
        <Route path=":id" element={<CategoryProducts />} />
        
        {/* Product Detail Page */}
        <Route path="product/:id" element={<ProductDetailPage />} />
        
        {/* Basket/Checkout Page */}
        <Route path="basket" element={<Checkout />} />
      </Route>
    </Routes>
  );
};

export default DlashopRoutes;